export default {
  SET_ALL_MAP_HOSTS (state, payload) {
    state.mapHosts = payload
  },
  SET_CURRENT_MAP_HOST (state, payload) {
    state.currentMapHost = payload
  },
  SET_CURRENT_MAP_HOST_OBJ (state, payload) {
    state.currentMapHostObj = payload
  }
}
